import script from "./Licensing.vue?vue&type=script&setup=true&lang=js"
export * from "./Licensing.vue?vue&type=script&setup=true&lang=js"

import "./Licensing.vue?vue&type=style&index=0&id=29e36b58&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e36b58"]])

export default __exports__